import {
  Invoice,
  LogoEn,
  PdfIcon,
  QuotationsIconWithoutBg,
} from "../components/styled/AllImages";
import { LazyImage } from "../components/styled/Elements";

export const establishmentInit = [
  {
    id: 1,
    label: "name",
    text: "Vertex Solutions",
  },
  {
    id: 2,
    label: "type",
    text: "Government",
  },
  {
    id: 3,
    label: "Sector",
    text: "IT Sector",
  },
  {
    id: 4,
    label: "description",
    text: "Office Management System is dedicated to streamlining administrative tasks, organizing workflows, and managing office resources, ensuring secure, efficient, and productive operations across your organization.",
  },
];
export const ClientInit = [
  {
    id: 1,
    label: "type",
    text: "Organization",
  },
  {
    id: 2,
    label: "name_en",
    text: "حلول نوفا إيدج",
  },
  {
    id: 3,
    label: "name_ar",
    text: "Nova Edge Solutions",
  },
  {
    id: 4,
    label: "email",
    text: "novaedgesolution@example.com",
  },
  {
    id: 5,
    label: "tax_registration_number",
    text: "123456789",
  },
];
export const establishmentLocation = [
  {
    id: 1,
    label: "Country",
    text: "",
  },
  {
    id: 2,
    label: "City",
    text: "",
  },
  {
    id: 3,
    label: "Address",
    text: "",
  },
];
export const establishmentContact = [
  {
    id: 1,
    label: "ContactNo",
    text: "",
  },
  {
    id: 2,
    label: "email",
    text: "",
  },
];

export const establishmentCurrency = [
  {
    id: 1,
    label: "currency",
    text: "",
  },
  {
    id: 1,
    label: "tax_number",
    text: "",
  },
  {
    id: 1,
    label: "tax_percentage",
    text: "",
  },
];
export const establishmentUploads = [
  {
    id: 1,
    label: "Logo",
    text: "",
    image: LogoEn,
  },
];
export const ClientUploads = [
  {
    id: 1,
    label: "cr",
    text: "dummy.pdf",
    image: PdfIcon,
  },
  {
    id: 2,
    label: "profile",
    text: "dummy.pdf",
    image: PdfIcon,
  },
  {
    id: 3,
    label: "contact_person_business_card",
    text: "dummy.pdf",
    image: PdfIcon,
  },
  {
    id: 4,
    label: "other",
    text: "dummy.pdf",
    image: PdfIcon,
  },
];

export const ClientLocation = [
  {
    id: 1,
    label: "Address",
    text: "1234 King Faisal Road, Al Noor District, Riyadh, 11564, Saudi Arabia",
  },
  {
    id: 2,
    label: "City",
    text: "Riyadh",
  },
  {
    id: 3,
    label: "street_name",
    text: "Sultan Street",
  },
  {
    id: 4,
    label: "sub_number",
    text: "85765765765",
  },
  {
    id: 5,
    label: "postal_code",
    text: "687684475868",
  },
  {
    id: 6,
    label: "commercial_registration_number",
    text: "47567657673",
  },
  {
    id: 7,
    label: "building_number",
    text: "898",
  },
  {
    id: 8,
    label: "region",
    text: "Riyadh Region",
  },
];
export const ClientContact = [
  {
    id: 1,
    label: "fax_number",
    text: "+966 333 854 741",
  },
  {
    id: 2,
    label: "phone",
    text: "+966 898 859 741",
  },
  {
    id: 2,
    label: "mobile",
    text: "+966 963 852 741",
  },
];

export const cityOptions = [
  {
    label: "riyadh",
    value: 1,
  },
  {
    label: "jeddah",
    value: 2,
  },
];
export const estTypeOptions = [
  {
    label: "Government",
    value: 1,
  },
  {
    label: "Government 2",
    value: 2,
  },
];
export const estSectorOptions = [
  {
    label: "ITSector",
    value: 1,
  },
];
export const estCountryOptions = [
  {
    label: "SaudiArabia",
    value: 1,
  },
];
export const estCityOptions = [
  {
    label: "Riyadh",
    value: 1,
  },
  {
    label: "Jeddah",
    value: 2,
  },
];

export const viewHqBranch = [
  {
    id: 1,
    label: "type",
    text: "Headquarter",
  },
  {
    id: 2,
    label: "name_en",
    text: "North Region Branch",
  },
  {
    id: 3,
    label: "name_ar",
    text: "فرع المنطقة الشمالية",
  },
  {
    id: 4,
    label: "initial_name",
    text: "North Region",
  },
];

export const viewHqBranchLocation = [
  {
    id: 1,
    label: "Country",
    text: "Saudi Arabia",
  },
  {
    id: 2,
    label: "City",
    text: "Jeddah",
  },
  {
    id: 3,
    label: "building",
    text: "Al Faisaliah Tower",
  },
  {
    id: 4,
    label: "floor",
    text: "6th",
  },
  {
    id: 5,
    label: "office",
    text: "654",
  },
  {
    id: 6,
    label: "address",
    text: "P.O. Box: 84261,Riyadh,Saudi Arabia",
  },
];

export const adHqBranchOptions = [
  {
    label: "NorthRegionBranch",
    value: 1,
  },
];
export const adDepartmentOptions = [
  {
    label: "ITDepartment",
    value: 1,
  },
];
export const basicPlanCheckList = [
  {
    id: 1,
    listTxt: "Upto5ArchivesAllowed",
  },
  {
    id: 2,
    listTxt: "BasicSupport",
  },
  {
    id: 3,
    listTxt: "AccessfromAnyDevice",
  },
];
export const professionalPlanCheckList = [
  {
    id: 1,
    listTxt: "UnlimitedArchives",
  },
  {
    id: 2,
    listTxt: "PrioritySupport",
  },
  {
    id: 3,
    listTxt: "AccessfromAnyDevice",
  },
];
export const enterprisePlanCheckList = [
  {
    id: 1,
    listTxt: "UnlimitedArchives",
  },
  {
    id: 2,
    listTxt: "TailoredFeaturesandIntegrations",
  },
  {
    id: 3,
    listTxt: "DedicatedAccountManager",
  },
  {
    id: 4,
    listTxt: "ContactSalesTeamCustomizedSolution",
  },
];

export const contactRoleOptions = [
  {
    label: "Role",
    value: 1,
  },
];
export const contactSaleCountryOptions = [
  {
    label: "SaudiArabia",
    value: 1,
  },
];

export const departmentsHeadings = [
  {
    nameEn: "ID",
    nameAr: "رقم الهوية",
    index: 1,
  },
  {
    nameEn: "Name",
    nameAr: "الاسم",
    index: 2,
  },
  {
    nameEn: "City",
    nameAr: "المدينة",
    index: 3,
  },
  {
    nameEn: "Email",
    nameAr: "إيميل",
    index: 4,
  },
  {
    nameEn: "Phone",
    nameAr: "الهاتف",
    index: 5,
  },
];

export const hqBranchesHeadings = [
  {
    nameEn: "ID",
    nameAr: "رقم الهوية",
    index: 1,
  },
  {
    nameEn: "Type",
    nameAr: "النوع",
    index: 2,
  },
  {
    nameEn: "Name",
    nameAr: "الاسم",
    index: 3,
  },
  {
    nameEn: "City",
    nameAr: "المدينة",
    index: 4,
  },
  {
    nameEn: "Depts.",
    nameAr: "عدد الأقسام",
    index: 5,
  },
  {
    nameEn: "Users",
    nameAr: "المستخدمون",
    index: 6,
  },
];

export const userPermissionsRows = [
  {
    id: 1,
    module_name: "users",
    // open: 1,
    create: 1,
    view: 3,
    edit: 2,
    delete: 4,
    // view_history: 5,
    // download: 6,
  },
  // {
  //   id: 2,
  //   module_name: "meetings",
  //   open: 1,
  //   create: 2,
  //   view: 3,
  //   edit: 4,
  //   view_history: 5,
  //   download: 6,
  // },
  {
    id: 2,
    module_name: "products",
    create: 1,
    view: 3,
    edit: 2,
    delete: 4,
    // open: 1,
    // create: 2,
    // view: 3,
    // edit: 4,
    // view_history: 5,
    // download: 6,
  },
  {
    id: 3,
    module_name: "clients",
    create: 1,
    view: 3,
    edit: 2,
    delete: 4,
    // open: 1,
    // create: 2,
    // view: 3,
    // edit: 4,
    // view_history: 5,
    // download: 6,
  },
  {
    id: 4,
    module_name: "quotations",
    create: 1,
    view: 3,
    edit: 2,
    delete: 4,
    // open: 1,
    // create: 2,
    // view: 3,
    // edit: 4,
    // view_history: 5,
    // download: 6,
  },
  {
    id: 5,
    module_name: "sales_invoices",
    create: 1,
    view: 3,
    edit: 2,
    delete: 4,
    // open: 1,
    // create: 2,
    // view: 3,
    // edit: 4,
    // view_history: 5,
    // download: 6,
  },
];
export const tempUserPermissionsRows = [
  {
    id: 1,
    module_name: "contracts",
    view: 1,
    view_open: 2,
  },
  {
    id: 2,
    module_name: "sales",
    view: 1,
    view_open: 2,
  },
  {
    id: 3,
    module_name: "marketing",
    view: 1,
    view_open: 2,
  },
  {
    id: 4,
    module_name: "products",
    view: 1,
    view_open: 2,
  },
  {
    id: 5,
    module_name: "human_resources",
    view: 1,
    view_open: 2,
  },
  {
    id: 6,
    module_name: "administration",
    view: 1,
    view_open: 2,
  },
];

export const hqBranchRows = [
  {
    id: 1,
    type: "Headquarters",
    name: "NorthRegionBranch",
    city: "New York",
    no_of_departments: 5,
    no_of_users: 120,
    actions: "Manage",
  },
  {
    id: 2,
    type: "Regional Office",
    name: "NorthRegionBranch",
    city: "Los Angeles",
    no_of_departments: 3,
    no_of_users: 80,
    actions: "Manage",
  },
  {
    id: 3,
    type: "Branch Office",
    name: "NorthRegionBranch",
    city: "Chicago",
    no_of_departments: 4,
    no_of_users: 95,
    actions: "Manage",
  },
  {
    id: 4,
    type: "Branch Office",
    name: "NorthRegionBranch",
    city: "Houston",
    no_of_departments: 2,
    no_of_users: 50,
    actions: "Manage",
  },
  {
    id: 5,
    type: "Headquarters",
    name: "NorthRegionBranch",
    city: "Boston",
    no_of_departments: 6,
    no_of_users: 150,
    actions: "Manage",
  },
];
export const dummyPlansList = [
  {
    id: 1,
    title: "BasicPlanFree",
    description: "EssentialToolsGetStarted",
    category: "free",
    price: 0,
    duration: "monthly",
    features_en: JSON.stringify([
      "Manage up to 3 Projects",
      "Basic Task & Calendar Features",
      "Email Support",
      "Access from Any Device",
    ]),
    features_ar: JSON.stringify([
      "إدارة ما يصل إلى 3 مشاريع",
      "ميزات المهام والتقويم الأساسية",
      "دعم البريد الإلكتروني",
      "الوصول من أي جهاز",
    ]),
  },
  {
    id: 2,
    title: "ProfessionalPlan",
    description: "AdvancedToolsGrowingTeams",
    category: "pro",
    price: 300,
    duration: "monthly",
    features_en: JSON.stringify([
      "Unlimited Projects & Tasks",
      "Team Collaboration Tools",
      "Priority Email & Chat Support",
      "Integration with Google Workspace",
      "Access from Any Device",
    ]),
    features_ar: JSON.stringify([
      "مشاريع ومهام غير محدودة",
      "أدوات التعاون بين الفرق",
      "دعم البريد الإلكتروني والدردشة المميز",
      "التكامل مع Google Workspace",
      "الوصول من أي جهاز",
    ]),
  },
];

export const imageGalleryData = [
  {
    src: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house exterior",
  },
  {
    src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2053&q=80",
    alt: "Modern house interior",
  },
  {
    src: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house pool",
  },
  {
    src: "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house bedroom",
  },
  {
    src: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house pool",
  },
  {
    src: "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house bedroom",
  },
];

export const videoGalleryData = [
  {
    src: "https://www.w3schools.com/html/mov_bbb.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 1",
  },
  {
    src: "https://www.w3schools.com/html/movie.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 2",
  },
  {
    src: "https://www.w3schools.com/html/mov_bbb.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 3",
  },
  {
    src: "https://www.w3schools.com/html/mov_bbb.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 5",
  },
];

export const prodTileArray = [
  {
    icon: Invoice,
    count: "0",
    color: "var(--white)",
    bg: "var(--green)",
    title: "invoice_addition_count",
  },
  {
    icon: QuotationsIconWithoutBg,
    count: "0",
    color: "var(--white)",
    bg: "var(--orange)",
    title: "quotation_addition_count",
  },
];

export const invoiceRows = [
  {
    no: "001",
    invoice_no: "INV-2025-001",
    date: "12-01-2023",
    client: "Eleanor Pena",
    quantity: 738,
    unit_price: "SAR 6.48",
    total_price: "SAR 6048",
  },
  {
    no: "002",
    invoice_no: "INV-2025-002",
    date: "28-02-2024",
    client: "Jerome Bell",
    quantity: 453,
    unit_price: "SAR 8.99",
    total_price: "SAR 8399",
  },
  {
    no: "003",
    invoice_no: "INV-2025-003",
    date: "05-03-2025",
    client: "Floyd Miles",
    quantity: 426,
    unit_price: "SAR 8.99",
    total_price: "SAR 8589",
  },
  {
    no: "004",
    invoice_no: "INV-2025-004",
    date: "18-04-2022",
    client: "Jacob Jones",
    quantity: 556,
    unit_price: "SAR 14.81",
    total_price: "SAR 1481",
  },
  {
    no: "005",
    invoice_no: "INV-2025-005",
    date: "30-05-2023",
    client: "Esther Howard",
    quantity: 922,
    unit_price: "SAR 14.81",
    total_price: "SAR 1481",
  },
  {
    no: "006",
    invoice_no: "INV-2025-006",
    date: "14-06-2024",
    client: "Dianne Russell",
    quantity: 536,
    unit_price: "SAR 11.70",
    total_price: "SAR 1170",
  },
];
